import React from 'react';
import { Button } from '../ui/Button';
import { Check, ShieldCheck, Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-stone-50" data-id="element-73">
      <div className="container mx-auto px-4" data-id="element-74">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-100" data-id="element-75">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-76">
            <div className="p-8 md:p-12 bg-stone-900 text-white flex flex-col justify-between relative overflow-hidden" data-id="element-77">
              <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-red-600 rounded-full blur-2xl opacity-50" data-id="element-78"></div>

              <div data-id="element-79">
                <h3 className="text-2xl font-bold mb-2" data-id="element-80">
                  No Pienses, Solo Cocina
                </h3>
                <p className="text-stone-400 mb-6" data-id="element-81">
                  Calendario 12 semanas + Sistema
                </p>

                <div className="flex items-baseline gap-2 mb-8" data-id="element-82">
                  <span className="text-5xl font-bold text-white" data-id="element-83">$6.39</span>
                  <span className="text-xl text-stone-500 line-through" data-id="element-84">
                    $49
                  </span>
                  <span className="text-sm font-bold text-green-400 bg-green-400/10 px-2 py-1 rounded" data-id="element-85">
                    AHORRAS 87%
                  </span>
                </div>
              </div>

              <div className="space-y-4 mb-8" data-id="element-86">
                <div className="flex items-center gap-3" data-id="element-87">
                  <div className="bg-green-500/20 p-1 rounded-full" data-id="element-88">
                    <Check className="h-4 w-4 text-green-400" data-id="element-89" />
                  </div>
                  <span className="text-stone-200" data-id="element-90">Acceso inmediato (PDF)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-91">
                  <div className="bg-green-500/20 p-1 rounded-full" data-id="element-92">
                    <Check className="h-4 w-4 text-green-400" data-id="element-93" />
                  </div>
                  <span className="text-stone-200" data-id="element-94">
                    Actualizaciones futuras gratis
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-95">
                  <div className="bg-green-500/20 p-1 rounded-full" data-id="element-96">
                    <Check className="h-4 w-4 text-green-400" data-id="element-97" />
                  </div>
                  <span className="text-stone-200" data-id="element-98">
                    Garantía de satisfacción
                  </span>
                </div>
              </div>
            </div>

            <div className="p-8 md:p-12 flex flex-col justify-center bg-white" data-id="element-99">
              <div className="text-center mb-8" data-id="element-100">
                <div className="flex justify-center mb-4" data-id="element-101">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-102" />)}
                </div>
                <p className="text-lg font-medium text-stone-900 mb-2" data-id="element-103">
                  "La forma más fácil de volver a comer en casa."
                </p>
                <p className="text-sm text-stone-500" data-id="element-104">
                  Únete a cientos de personas que ya recuperaron sus cenas.
                </p>
              </div>

              <Button size="lg" className="w-full mb-4 text-lg shadow-red-200" href="https://www.nachogerberg.com/cart/42520401117255:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'AddToCart', {
                  content_name: 'No Pienses Solo Cocina - 12 Semanas',
                  content_type: 'product',
                  value: 6.39,
                  currency: 'USD'
                });
              }
            }} data-id="element-105">
                QUIERO MIS 12 SEMANAS LISTAS
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-stone-400" data-id="element-106">
                <ShieldCheck className="h-4 w-4" data-id="element-107" />
                <span data-id="element-108">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}